export default "__VITE_ASSET__Bt1sfr9S__"